<div class="content">
    <div class="brand">
        <button
            type="button"
            class="menu"
            [attr.aria-label]="(menuOpen() ? 'header.menu.close' : 'header.menu.open') | translate"
            [attr.aria-expanded]="menuOpen()"
            (click)="menuOpen.set(!menuOpen())"
        >
            <cl-icon [icon]="menuOpen() ? icons.X : icons.Menu" />
        </button>
        <app-logo class="logo" />
        <span class="label">Admin</span>
    </div>
    <div class="actions">
        <button type="button" class="theme-toggle" (click)="themeService.toggle()" [attr.aria-label]="'header.theme.toggle' | translate">
            <cl-icon [icon]="themeService.theme() === 'dark' ? icons.Sun : icons.Moon" />
        </button>
        <a routerLink="/profile">
            <app-avatar [label]="initials()" [text]="$safeNavigationMigration(profile()?.email)" />
        </a>
        <a routerLink="/auth/logout" class="logout" [attr.aria-label]="'header.logout' | translate"><cl-icon [icon]="icons.LogOut" /></a>
    </div>
</div>
